import {
  HeaderLeftContent,
  HeaderRightContent,
  StyledHeader,
} from "../Common/styles/header";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { Sync } from "@mui/icons-material";

type Props = {
  onSync: () => void;
  syncing: boolean;
};

const EmailTemplatesHeader = ({ onSync, syncing }: Props) => {
  return (
    <StyledHeader
      sx={{
        borderBottom: "1px solid #E0E3EB",
      }}
    >
      <Box sx={HeaderLeftContent}>
        <Typography variant="h2" color="text.primary">
          Email Templates
        </Typography>
      </Box>
      <Box sx={HeaderRightContent}>
        <Button
          variant="contained"
          startIcon={
            syncing ? <CircularProgress size={16} color="inherit" /> : <Sync />
          }
          onClick={onSync}
          disabled={syncing}
        >
          Sync
        </Button>
      </Box>
    </StyledHeader>
  );
};

export default EmailTemplatesHeader;
